import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Paper, Typography } from '@mui/material';
import React from 'react';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqSectionProps {
  title?: string;
  items?: FaqItem[];
}

const FaqSection: React.FC<FaqSectionProps> = ({ title = 'Frequently Asked Questions', items }) => {
  if (!items || items.length === 0) return null;

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        {title}
      </Typography>
      {items.map((item, idx) => (
        <Accordion key={`${item.q}-${idx}`} disableGutters>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {item.q}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              {item.a}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Paper>
  );
};

export default React.memo(FaqSection);
